import cx from 'classnames';

type OwnProps = {
  options: {
    strong?: string;
    text?: string;
  };
  isMobile: any;
};

export default function CTTooltipContent({
  options: { strong, text },
  isMobile
}: OwnProps) {
  return (
    <div
      className={cx('ct-tooltip__text', {
        mobile: isMobile
      })}
    >
      <strong>{strong}</strong>
      <p
        className={cx('ct-tooltip__paragraph', {
          mobile: isMobile
        })}
      >
        {text}
      </p>
    </div>
  );
}
